import React from 'react';
import { Link as ReactLink } from 'react-router-dom';
import styled from 'styled-components';
import translations from 'translations';
import topNavMessage from './messages';

const QuickOrderIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <g clip-path="url(#clip0_10179_8269)">
        <path
          d="M13.9366 11.2013C13.9434 11.2414 13.8905 11.3269 13.8529 11.3408L12.721 11.7961C12.3164 11.9584 11.9715 12.2689 11.8076 12.6875L11.3244 13.9173C11.3108 13.9505 11.2339 14.0133 11.2066 13.9976L11.0939 13.9278L10.6142 12.684C10.4366 12.2863 10.1345 11.981 9.74008 11.8118L8.54669 11.3286L8.49206 11.2292C8.4767 11.1995 8.52791 11.1158 8.56206 11.1019L9.70081 10.6396C10.114 10.4721 10.4469 10.1634 10.6142 9.73947L11.0922 8.52362C11.1042 8.49048 11.1725 8.43815 11.2066 8.4364C11.2408 8.4364 11.3125 8.48524 11.3296 8.52711L11.782 9.69237C11.9527 10.1337 12.2856 10.4634 12.7142 10.6361L13.841 11.0896C13.8751 11.1036 13.9297 11.1664 13.9366 11.2013Z"
          fill="#111827"
        />
        <path
          d="M7.32771 9.101L5.79287 4.20445C5.77239 4.1434 5.67849 4.07886 5.62727 4.07886H4.91021C4.85729 4.07886 4.77022 4.14514 4.74973 4.20969L3.21147 9.11147C3.17221 9.24055 3.27123 9.34522 3.37879 9.34522L3.80219 9.34871C3.85512 9.35045 3.95926 9.28765 3.97463 9.24055L4.22047 8.43115H6.31018L6.56798 9.23532C6.58505 9.2894 6.68066 9.34696 6.73358 9.35045L7.16211 9.34696C7.2065 9.34522 7.29357 9.29986 7.31576 9.26323C7.33454 9.23183 7.34308 9.1481 7.32771 9.101ZM4.47656 7.64617L5.27386 5.1412L6.07116 7.64617H4.47656Z"
          fill="#111827"
        />
        <path
          d="M9.27059 4.28117V9.14806C9.27059 9.2475 9.2023 9.34344 9.10157 9.34344L8.69012 9.34693C8.58256 9.34693 8.50232 9.26668 8.50232 9.14806V4.28117C8.50232 4.16081 8.58256 4.08057 8.69183 4.08057H9.08109C9.19035 4.08057 9.27059 4.16081 9.27059 4.28117Z"
          fill="#111827"
        />
        <path
          d="M11.0108 2.9047C11.0107 2.55037 10.7264 2.24561 10.3562 2.24561H2.8104C2.44098 2.24561 2.15584 2.5496 2.15579 2.9047V10.7962C2.15579 11.1506 2.44019 11.4553 2.8104 11.4553H7.33469V12.4471H2.8104C1.93088 12.4471 1.20422 11.7153 1.20422 10.7962V2.9047C1.20427 1.98299 1.93356 1.25439 2.8104 1.25439H10.3562C11.2357 1.25439 11.9623 1.9857 11.9623 2.9047V6.86271H11.0108V2.9047Z"
          fill="#111827"
        />
      </g>
      <defs>
        <clipPath id="clip0_10179_8269">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const Link = styled(ReactLink)`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  display: flex;
  gap: 5px;
  align-items: center;
  cursor: pointer;
`;

const QuickOrderLink = () => {
  return (
    <Wrapper>
      <QuickOrderIcon />
      <Link to="/quick-order">{translations(topNavMessage.quickOrderLink)}</Link>
    </Wrapper>
  );
};

export default QuickOrderLink;
